import { createSlice } from '@reduxjs/toolkit'

export const sidebarSlice = createSlice({
  name: 'sidebar',
  initialState: {
    isOpen: true,
  },
  reducers: {
    toggle: (state,action) => {
      return {
        isOpen: action.payload.isOpen,
      }
    }
  },
})

// Action creators are generated for each case reducer function
export const { toggle } = sidebarSlice.actions

export default sidebarSlice.reducer